import * as React from "react"

import { Circle, Container, StyledIcon, Text } from "./Styles"

const DetailsNone = ({ text }: { text: string }): JSX.Element => {
  return (
    <Container data-testid="catalog-none-selected">
      <Circle>
        <StyledIcon code="west" />
        <Text>{text}</Text>
      </Circle>
    </Container>
  )
}

export default DetailsNone
